/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Inspection } from '../../models/inspection';

export interface ApiV0InspectionGetByCompanyGet$Json$Params {
  CompanyId?: string;
}

export function apiV0InspectionGetByCompanyGet$Json(http: HttpClient, rootUrl: string, params?: ApiV0InspectionGetByCompanyGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Inspection>>> {
  const rb = new RequestBuilder(rootUrl, apiV0InspectionGetByCompanyGet$Json.PATH, 'get');
  if (params) {
    rb.query('CompanyId', params.CompanyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Inspection>>;
    })
  );
}

apiV0InspectionGetByCompanyGet$Json.PATH = '/api/v0/inspection/getByCompany';
